import { useMemo } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { ISODate } from '@amzn/storm-ui-date-picker-v3';
import dt from '@urc-ui/components/date-input/utils/date-time-fns';
import { UseDatePickerDatesProps } from './types';
import { ISO_DATE_FORMAT } from '@urc-ui/components/date-input/utils/constants';

/**
 * Memoizes initial date calculates for the date picker
 *
 * @param todayUtc current date UTC
 * @param timeZone marketplace timezone
 * @param initialDateUtc optional initial date selection
 */
const useDatePickerDates = ({ todayUtc, timeZone, initialDate }: UseDatePickerDatesProps) => {
  const todayISO = formatInTimeZone(todayUtc, timeZone, ISO_DATE_FORMAT) as ISODate;
  const initialDateIso = initialDate ? (formatInTimeZone(initialDate, timeZone, ISO_DATE_FORMAT) as ISODate) : null;

  return useMemo(() => {
    const tomorrow = dt.composeInTZ({ zone: timeZone }, dt.addDays(1));
    return { tomorrow, initialDate: initialDate || tomorrow };
  }, [todayISO, initialDateIso, timeZone]);
};

export { useDatePickerDates };
export type { UseDatePickerDatesProps };
